<template>
  <div>
    <BannerHero />
    <BrandsSection />
    <YourBusiness />
    <PlatformAudience />
    <AppointmentsComparison />
    <GetStarted
      class="guide-divider"
      cta="Try scheduling for A$1"
      heading="Book clients in minutes—activate scheduling for just A$1 today."
      caption="Jump in free, test every service tool instantly, and upgrade only when paid features boost your growth."
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BannerHero from "@/components/heros/AppointmentsBanner.vue";
import BrandsSection from "@/components/sections/Brands.vue";
import YourBusiness from "@/components/sections/AppointmentsYourBusiness.vue";
import PlatformAudience from "@/components/sections/PlatformAudience.vue";
import AppointmentsComparison from "@/components/sections/AppointmentsComparison.vue";
import GetStarted from "@/components/sections/GetStarted.vue";

export default defineComponent({
  components: {
    BannerHero,
    YourBusiness,
    BrandsSection,
    PlatformAudience,
    AppointmentsComparison,
    GetStarted,
  },
  setup() {
    const keywords = seoKeywords();

    definePageMeta({
      layout: "sell",
      seo: {
        title: "Orie Appointments",
        description:
          "Online booking system for your business. Let clients schedule appointments, get reminders and securely pay online. Get started free!",
        keywords: keywords.sell.services,
      },
    });
  },
});
</script>
